<template>
  <div>
    <!-- toasts message -->
       <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

 
    <!-- <packageRevForm :formSchema="formSchema" v-on:emitCloseModal="close"></packageRevForm> -->

    <v-card-title>
      <h2> Procurement Package Revision </h2>
      <v-spacer></v-spacer>
      <!-- <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field> -->
    </v-card-title>



    <v-data-table
      v-bind:headers="headers"
      v-bind:items="desserts"
      v-bind:search="search"
      v-bind:pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ ++(props.index) }}</td>
        <td class="text-xs-left">{{ props.item.package_no }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.type_name }}</td>
        <td class="text-xs-left">{{ props.item.unit_name }}</td>
        <td class="text-xs-left">{{ props.item.quantity }}</td>
        <td class="text-xs-left">{{ props.item.estimated_price | currency }}</td>
        <td class="text-xs-left">{{ props.item.method_name }}</td>
        <td class="text-xs-left">{{ props.item.from_date }}</td>
        <td class="text-xs-left">{{ props.item.to_date }}</td>
        <td class="text-xs-left">
          <v-btn
            color="primary"
            dark
            slot="activator"
            class="mb-2"
            @click="editItem(props.index, props.item)"
          >Revision</v-btn>
        </td>
        
        
        <td class="justify-center layout px-0">
         
        </td>
      </template>

       <template slot="no-data" class="error">
        <div align="center">No Data Found</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

//import packageRevForm from "./packageRevForm.vue";
import { preFix } from "../../../vuex/api";
import Axios from "axios";

export default {
  // components: {
  //   packageRevForm
  // },

  data: () => ({ dialog: false,
    totalItems: 0,
 /**  data table */
    serialNumber: 0,
    sort: '',
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },
    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    
    headers: [
      {
        text: "SL",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Package Number",
        align: "left",
        sortable: true,
        value: "package_no",
      },

      {
        text: "Package Name",
        align: "left",
        sortable: true,
        value: "name",
      },
      {
        text: "Procurement Type",
        align: "left",
        sortable: true,
        value: "type_name",
      },
      {
        text: "Unit",
        align: "left",
        sortable: true,
        value: "unit_name",
      },
      {
        text: "Quantity",
        align: "left",
        sortable: true,
        value: "quantity",
      },
      {
        text: "Estimated Price",
        align: "left",
        sortable: true,
        value: "estimated_price",
      },
      {
        text: "Method",
        align: "left",
        value: "method_name",
      },
      {
        text: "Start Date",
        align: "left",
        value: "from_date",
      },
      {
        text: "End Date",
        align: "left",
        value: "to_date",
      },
      {
        text: "Action",
        align: "center",
        value: "",
      },
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    projectId: sessionStorage.getItem('proId'),
    leaveTypeModal: false, 
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },
     params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  watch:{
    params: {
      handler() {
        this.getDataFromApi().then(data => {          
          this.desserts = data.items;
          this.totalDesserts = data.totalRecords;
        });
      },
      deep: true
    }
  },

  mounted() {
    this.loadData();
   this.SnackbarVal.color = "success";
      this.SnackbarVal.message = "Data Loading";
      this.SnackbarVal.snackbar = true;
  },

  methods: {
    loadData(pagination) {
      commonService.getAllData("proc_packages").then(res => {
        this.items = res.data;
        this.loading = false;
      });
    },

     getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
          this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "procurement-package-info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },


    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      sessionStorage.setItem("package_info", item.id);      
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$router.push('/procurement/new_revision');
    },

   
    close(message) {
      this.leaveTypeModal = false;
      if (message != 0) {
        this.SnackbarVal.color = "success";
      this.SnackbarVal.message = message;
      this.SnackbarVal.snackbar = true;
        this.loadData();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package_revision/package_rev_list.vue